import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { Observable, of, Subscription } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
} from 'rxjs/operators';

const DATAFORSYNINGEN_POSTNUMRE_URL =
  'https://api.dataforsyningen.dk/postnumre';

interface DataforsyningenPostnummer {
  navn?: string;
}

export function normalizeDanishPostalCode(value: unknown): string | null {
  const digits = String(value ?? '').replace(/\D/g, '');
  return /^\d{4}$/.test(digits) ? digits : null;
}

export function fetchDanishCityName(
  http: HttpClient,
  postalCode: string
): Observable<string | null> {
  return http
    .get<DataforsyningenPostnummer>(
      `${DATAFORSYNINGEN_POSTNUMRE_URL}/${postalCode}`
    )
    .pipe(
      map((res) => res?.navn?.trim() || null),
      catchError(() => of(null))
    );
}

/** Udfylder by automatisk når et gyldigt dansk postnummer (4 cifre) indtastes. */
export function bindDanishPostalCodeCityLookup(
  form: FormGroup,
  http: HttpClient,
  postalControlName = 'postal_code',
  cityControlName = 'city'
): Subscription {
  const postalControl = form.get(postalControlName);
  const cityControl = form.get(cityControlName);
  if (!postalControl || !cityControl) {
    return new Subscription();
  }

  return postalControl.valueChanges
    .pipe(
      debounceTime(300),
      map((value) => normalizeDanishPostalCode(value)),
      distinctUntilChanged(),
      switchMap((code) =>
        code ? fetchDanishCityName(http, code) : of(null)
      ),
      filter((city): city is string => !!city)
    )
    .subscribe((city) => {
      cityControl.setValue(city, { emitEvent: false });
    });
}
